export const CAR_AMIGO_FUELS = [
  {
    id: 'B',
    details: [
      { lang: 'fr', fuel_name: 'Essence' },
      { lang: 'en', fuel_name: 'Gasoline/Petrol' },
    ],
  },
  {
    id: 'D',
    details: [
      { lang: 'fr', fuel_name: 'Diesel' },
      { lang: 'en', fuel_name: 'Diesel' },
    ],
  },
  {
    id: '2',
    details: [
      { lang: 'fr', fuel_name: 'Electrique/Essence' },
      { lang: 'en', fuel_name: 'Electric/Gasoline' },
    ],
  },
  {
    id: '3',
    details: [
      { lang: 'fr', fuel_name: 'Electrique/Diesel' },
      { lang: 'en', fuel_name: 'Electric/Diesel' },
    ],
  },
  {
    id: 'C',
    details: [
      { lang: 'fr', fuel_name: 'CNG' },
      { lang: 'en', fuel_name: 'CNG' },
    ],
  },
  {
    id: 'E',
    details: [
      { lang: 'fr', fuel_name: 'Electrique' },
      { lang: 'en', fuel_name: 'Electric' },
    ],
  },
  {
    id: 'H',
    details: [
      { lang: 'fr', fuel_name: 'Hydrogène' },
      { lang: 'en', fuel_name: 'Hydrogen' },
    ],
  },
  {
    id: 'L',
    details: [
      { lang: 'fr', fuel_name: 'LPG' },
      { lang: 'en', fuel_name: 'LPG' },
    ],
  },
  {
    id: 'M',
    details: [
      { lang: 'fr', fuel_name: 'Méthanol' },
      { lang: 'en', fuel_name: 'Methanol' },
    ],
  },
  {
    id: 'O',
    details: [
      { lang: 'fr', fuel_name: 'Autres' },
      { lang: 'en', fuel_name: 'Others' },
    ],
  },
];

export const CAR_AMIGO_BODYTYPES = [
  {
    id: '1',
    details: [
      { lang: 'fr', name: 'Citadine' },
      { lang: 'en', name: '' },
    ],
  },
  {
    id: '2',
    details: [
      { lang: 'fr', name: 'Cabriolet' },
      { lang: 'en', name: 'Convertible' },
    ],
  },
  {
    id: '3',
    details: [
      { lang: 'fr', name: 'Coupe' },
      { lang: 'en', name: 'Coupe' },
    ],
  },
  {
    id: '4',
    details: [
      { lang: 'fr', name: 'SUV/4x4/Pickup' },
      { lang: 'en', name: 'SUV/4x4/Pickup' },
    ],
  },
  {
    id: '5',
    details: [
      { lang: 'fr', name: 'Break' },
      { lang: 'en', name: 'Break' },
    ],
  },
  {
    id: '6',
    details: [
      { lang: 'fr', name: 'Berline' },
      { lang: 'en', name: 'Sedan' },
    ],
  },
  {
    id: '12',
    details: [
      { lang: 'fr', name: 'Monospace' },
      { lang: 'en', name: 'Minivan' },
    ],
  },
  {
    id: '13',
    details: [
      { lang: 'fr', name: 'Utilitaire' },
      { lang: 'en', name: 'Utilitaire' },
    ],
  },
  {
    id: '7',
    details: [
      { lang: 'fr', name: 'Autres' },
      { lang: 'en', name: 'Others' },
    ],
  },
];

export const CAR_AMIGO_GEARBOX = [
  {
    id: 'A',
    details: [
      { lang: 'fr', name: 'Boîteautomatique' },
      { lang: 'en', name: 'Automatic Transmission' },
    ],
  },
  {
    id: 'M',
    details: [
      { lang: 'fr', name: 'Boîtemanuelle' },
      { lang: 'en', name: 'Manual Transmission' },
    ],
  },
  {
    id: 'S',
    details: [
      { lang: 'fr', name: 'Semi-automatique' },
      { lang: 'en', name: 'Semi-automatic' },
    ],
  },
];

export const CAR_AMIGO_COLORS = [
  { id: '1', name: 'BEIGE' },
  { id: '10', name: 'RED' },
  { id: '11', name: 'BLACK' },
  { id: '12', name: 'SILVER' },
  { id: '13', name: 'PURPLE' },
  { id: '14', name: 'WHITE' },
  { id: '15', name: 'ORANGE' },
  { id: '16', name: 'GOLD' },
  { id: '2', name: 'BLUE' },
  { id: '3', name: 'BROWN' },
  { id: '5', name: 'YELLOW' },
  { id: '6', name: 'GREY' },
  { id: '7', name: 'GREEN' },
  { id: '4', name: 'CREME' },
];

export function getColorById(colorId) {
  if (!colorId) return '-';
  const color = CAR_AMIGO_COLORS.find(el => el.id === colorId);
  if (color) return color.name;
  return '-';
}

export function getBodyTypeById(bodyTypeId) {
  if (!bodyTypeId) return null;
  const bodyType = CAR_AMIGO_BODYTYPES.find(el => el.id === bodyTypeId);
  if (bodyType) return bodyType;
  return null;
}

export function getFuelById(fuelId) {
  if (!fuelId) return null;
  const fuel = CAR_AMIGO_FUELS.find(el => el.id === fuelId);
  if (fuel) return fuel;
  return null;
}

export function getGearboxType(gearboxId) {
  if (!gearboxId) return null;
  const gearbox = CAR_AMIGO_GEARBOX.find(el => el.id === gearboxId);
  if (gearbox) return gearbox;
  return null;
}

export const ImportToType = {
  both: 'both'
};

export const importTargetPortals = (publicSuffix) => {
  switch (publicSuffix) {
    case 'ci':
      return {
        auto24Portal: 'auto24.ci',
        africarPortal: 'voitures.ci'
      };
    case 'co.za':
      return {
        auto24Portal: 'auto24.co.za',
        africarPortal: 'imotoimoto.co.za'
      };
    case 'ma':
      return {
        auto24Portal: 'auto24.ma',
        africarPortal: 'voiturenet.ma'
      };
    case 'rw':
      return {
        auto24Portal: 'auto24.rw',
        africarPortal: 'carisoko.com'
      };
    case 'sn':
      return {
        auto24Portal: 'auto24.sn',
        africarPortal: 'gaaraas.com'
      };
    default:
      return {
        auto24Portal: 'dev-auto24',
        africarPortal: ''
      };
  }
};